<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="sendRequest(f)">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_FORGOT_PASSWORD4'"></h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <xrx-input
      type="email"
      id="email"
      name="email"
      [(ngModel)]="email"
      [maxlength]="318"
      placeholder="SDE_EMAIL2"
      [autofocus]="true"
      [required]="true"
      error="{{ error }}"
      label="SDE_TO_REQUEST_NEW"></xrx-input>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button type="submit" class="xrx-btn btn-primary" [disabled]="!f.valid">
        <span class="btn-label" [xdaTranslate]="'SDE_SEND_REQUEST'"></span>
      </button>
    </div>
  </div>
</form>
